"use client"

import { useEffect, useState } from "react";
import SetupSteps from "@/components/account/SetupSteps";
import PageLayout from "@/components/PageLayout";
import Title from "@/components/Title";
import { Link, redirect } from "@/i18n/navigation";
import { useTranslations, useLocale } from "next-intl";

import PasswordField from "./PasswordField";
import Envelope from "@/components/icons/envelope-outline.svg";

interface SignupFormProps {
  email?: string;
  submit: (email: string, password: string) => Promise<void>;
  errorTag?: string | null;
}

export default function SignupForm(props: SignupFormProps) {
  const t = useTranslations("OpenAccount");

  const [email, setEmail] = useState<string>(props.email || "");
  const [password, setPassword] = useState<string>("");
  const [conditionsAccepted, setConditionsAccepted] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(props.errorTag && t(props.errorTag) || null);

  useEffect(() => {
    if (errorMsg && errorMsg.length > 0) {
      setTimeout(() => {
        setErrorMsg(null);
      }, 5000);
    }
  }, [errorMsg]);

  const registerClick = () => {
    props.submit(email, password);
  }

  return (
    <PageLayout padded={true} gapPx={30}>
      <Title breadcrumbs={[]} title={t('registration')} />
      <div className="w-full md:flex flex-row justify-center md:p-2.5 md:gap-2.5">
        <SetupSteps currentStep={1} t={t} />
      </div>
      <div className="w-full flex flex-col items-center justify-center md:p-2.5 md:gap-2.5">
        <div className="flex flex-col p-2.5 gap-5">
          <div className="w-[300px] md:w-[380px] text-sm font-[Outfit]">
            {t('step_1_not_living_in_ch')}
            <br />
            <Link href={"/standorte"} className="underline cursor-pointer">
              {t('step_1_go_to_our_partners')}
            </Link>
          </div>
          <div className="w-[300px] md:w-[380px] flex flex-col gap-2.5">
            <label className="input w-full">
              <Envelope height={14} width={14} className="fill-base-content" />
              <input className="grow" type="email" placeholder={t('step_1_private_field-email-label')} onChange={e => setEmail(e.target.value)} value={email} {...(props.email ? { readOnly: true } : {})} />
            </label>
            <PasswordField
              value={password}
              onChange={setPassword}
              placeholder={t('step_1_company_field-password')}
            />
          </div>
          <div className="w-[300px] md:w-[380px] flex flex-col gap-2.5 text-black">
            <label className="label gap-2.5">
              <input type="checkbox" className="checkbox" onChange={() => setConditionsAccepted(!conditionsAccepted)} checked={conditionsAccepted} />
              <div className="text-wrap w-full text-sm">
                {t('step_1_t&c_confirmation_part_1')}
                {" "}
                <a className="underline" href="/agb" target="_blank">
                  {t('step_1_t&c_confirmation_t&c')}
                </a>
                {" "}
                {t('step_1_t&c_confirmation_part_2')}
                {" "}
                <a className="underline" href="/datenschutz" target="_blank">
                  {t('step_1_t&c_confirmation_privacy_policy')}
                </a>
                {" "}
                {t('step_1_t&c_confirmation_part_3')}
              </div>
            </label>
          </div>
          <button className="btn btn-secondary text-white rounded-full" onClick={registerClick} {...(!conditionsAccepted ? { disabled: true } : {})}>
            {t('step_1_company_field-submit')}
          </button>
        </div>
      </div>
      <div className="toast toast-end z-1000">
        {props.errorTag && (<div className="alert alert-error">
          <span>{t(props.errorTag)}</span>
        </div>)}
      </div>
    </PageLayout>
  )
}
